import BranchIcon from './branchIcon.component';

export default BranchIcon;
